/** @format */

import { v4 as uuidv4 } from 'uuid';

export const uuid = () => {
	let ret = '';
	try {
		ret = uuidv4().toString().trim().replaceAll('-', '');
	} catch (error) {
		ret = uuid2(32, 16);
	}
	return ret;
};

export const getRandom = () => {
	const array = new Uint32Array(1);
	window.crypto.getRandomValues(array);
	const token = array[0];
	return token * 0.01;
};

// 指定长度和基数
function uuid2(len, radix) {
	const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	const uuid: any = [];
	let i;
	radix = radix || chars.length;

	if (len) {
		// Compact form
		for (i = 0; i < len; i++) uuid[i] = chars[0 | (getRandom() * radix)];
	} else {
		// rfc4122, version 4 form
		let r;

		// rfc4122 requires these characters
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		// Fill in random data.  At i==19 set the high bits of clock sequence as
		// per rfc4122, sec. 4.1.5
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | (getRandom() * 16);
				uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
			}
		}
	}

	return uuid.join('');
}
